"use client"

interface FormInputProps {
    label?: string
    type?: string
    value: string | number
    onChange: (value: string) => void
    placeholder?: string
    error?: string
    required?: boolean
    min?: number | string
    max?: number | string
    step?: number
}

export default function FormInput({
    label,
    type = "text",
    value,
    onChange,
    placeholder,
    error,
    required = false,
    min,
    max,
    step,
}: FormInputProps) {
    return (
        <div>
            {label && (
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    {label} {required && <span className="text-red-500">*</span>}
                </label>
            )}
            <input
                type={type}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                min={min}
                max={max}
                step={step}
                className={`
          w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500
          ${error ? "border-red-300" : "border-gray-300"}
        `}
            />
            {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
        </div>
    )
}
